import { Link } from "react-router";
import {
  LANDING_ASSETS,
  LANDING_FOOTER_CONTACT,
  LANDING_PAGE_GUTTER,
  LANDING_SOCIAL,
} from "../constants/landing.constants";
import LandingIcon from "./LandingIcon";

const LEGAL_LINKS = (
  <>
    <Link to="/privacy" className="hover:opacity-90">
      Privacy Policy
    </Link>
    <Link to="/refund" className="hover:opacity-90">
      Refund Policy
    </Link>
    <Link to="/terms" className="hover:opacity-90">
      Terms &amp; Conditions
    </Link>
  </>
);

export default function LandingFooter() {
  return (
    <footer className="landing-footer">
      <div className={`landing-footer__content relative flex flex-col ${LANDING_PAGE_GUTTER}`}>
        <div className="landing-footer__main flex flex-1 flex-col items-center text-center">
          <img
            src={LANDING_ASSETS.logo}
            alt="Music Temple"
            className="mb-4 h-[clamp(72px,12vw,99px)] w-[clamp(98px,16vw,134px)] rounded-[20px] bg-white object-contain md:h-[99px] md:w-[134px]"
          />
          <a
            href="https://musictemple.in/"
            target="_blank"
            rel="noopener noreferrer"
            className="mb-5 text-[16px] font-medium capitalize leading-none hover:underline"
          >
            {LANDING_FOOTER_CONTACT.website}
          </a>

          <div className="mb-6 flex flex-col items-center gap-3 text-[14px] font-normal leading-[22px] md:flex-row md:gap-[8px]">
            <a
              href={`mailto:${LANDING_FOOTER_CONTACT.email}`}
              className="inline-flex flex-col items-center gap-1 hover:underline md:flex-row md:gap-2"
            >
              <LandingIcon name="mail" className="h-[11px] w-[15px] shrink-0 md:h-[18px] md:w-[18px]" />
              {LANDING_FOOTER_CONTACT.email}
            </a>
            <a
              href={`tel:${LANDING_FOOTER_CONTACT.phone.replace(/\s/g, "")}`}
              className="inline-flex flex-col items-center gap-1 hover:underline md:flex-row md:gap-2"
            >
              <LandingIcon name="phone" className="h-[18px] w-[19px] shrink-0" />
              {LANDING_FOOTER_CONTACT.phone}
            </a>
          </div>

          <div className="mb-8 flex items-center justify-center gap-6 text-[12px] font-normal leading-[19px] underline underline-offset-4 md:hidden">
            {LEGAL_LINKS}
          </div>

          <div className="mb-8 hidden items-center gap-[10px] md:flex">
            {LANDING_SOCIAL.map((social) => (
              <a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.label}
                className="flex h-9 w-9 items-center justify-center text-white transition-opacity hover:opacity-80"
              >
                <LandingIcon name={social.icon} className="h-5 w-5" />
              </a>
            ))}
          </div>
        </div>

        <div className="landing-footer__bottom pb-[clamp(16px,3vw,32px)] text-center text-[12px] font-normal leading-[19px] md:flex md:items-center md:justify-between md:text-left">
          <p>Copyright 2026 Music Temple. All Rights Reserved</p>
          <div className="mt-4 hidden items-center gap-6 underline underline-offset-4 md:mt-0 md:flex">
            {LEGAL_LINKS}
          </div>
        </div>
      </div>
    </footer>
  );
}
